import React from "react";
import { Stack, DetailsList, IColumn, PrimaryButton } from "@fluentui/react";
import { useNavigate } from "react-router-dom";
import { kyActivityPage } from "../../messages/ky-activity";
import { common } from "../../messages/common-items";
import { mockData } from "../../constants/global-values";

const { Labels: Lbl_KyActivity } = kyActivityPage;
const { Labels: Lbl_Common } = common;

const columns: IColumn[] = [
  { key: "column1", name: Lbl_KyActivity.DATE, fieldName: "date", minWidth: 100, isResizable: true },
  { key: "column2", name: Lbl_KyActivity.LEADER_NAME, fieldName: "leader", minWidth: 100, isResizable: true },
  { key: "column3", name: Lbl_KyActivity.FOREMAN_NAME, fieldName: "foreman", minWidth: 100, isResizable: true },
  {
    key: "column4",
    name: Lbl_KyActivity.DANGEROUS_WORK,
    fieldName: "tasks",
    minWidth: 150,
    onRender: (item) => <span>{item.tasks.join(", ")}</span>,
  },
  {
    key: "column5",
    name: Lbl_KyActivity.HAZARD_AVOIDANCE_MEASURES,
    fieldName: "risks",
    minWidth: 200,
    onRender: (item) => <span>{item.risks.join(", ")}</span>,
  },
];

const KYActivityListPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="background  list-background">
      <div className="form-container list-box">
        <h2>{Lbl_KyActivity.KYACTIVITY_LIST_PAGE}</h2>
        <Stack horizontal tokens={{ childrenGap: 20 }}>
          <PrimaryButton
            className="custom-primary-button"
            text={Lbl_Common.NEWITEM}
            onClick={() => {
              navigate(`/kyactivity`, { state: { from: "list" } });
            }}
          /></Stack>
        <DetailsList className="ky-details-list" items={mockData} columns={columns} />
      </div>
    </div>
  );
};
export default KYActivityListPage;